/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_FundingInputs */

const de__field_funding = /** @type {(inputs: _Field_FundingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förderbedarf`)
};

/**

* @param {_Field_FundingInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_funding = /** @type {((inputs?: _Field_FundingInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_FundingInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_funding(inputs)
});